/* «На карте» переносит результат того же отбора, который отрисовал страницу.
 * Hash хранит полный состав (до пагинации), query — исходные условия. Новый фильтр
 * не требует второго переводчика в контракт карты; пустой набор тоже явный.
 */
(() => {
  'use strict';
  const key = 'catalog-selection';
  const links = '#nvMapLink, .zk-minimap';
  let published = null;
  let pending = null;
  let pendingKey = null;
  const hashParams = () => new URLSearchParams(window.location.hash.slice(1));
  const snapshot = () => {
    // Встроенная карта подборки использует уже загруженную выдачу страницы.
    if (window.NvCatalog && document.getElementById('landingMapDialog')) {
      if (published === null) throw new Error('Catalog selection is not ready');
      return { items: published };
    }
    const hash = hashParams();
    if (!hash.has(key)) return new URL(window.location).searchParams.has('catalog_scope') ? { scope: true } : null;
    const raw = hash.get(key);
    const ids = raw === '' ? [] : raw.split(',');
    if (ids.some((id) => !/^[1-9][0-9]*$/.test(id)) || new Set(ids).size !== ids.length) {
      throw new Error('Invalid catalog selection');
    }
    return { ids };
  };
  const syncLink = () => {
    const button = document.getElementById('landingMapOpen');
    if (button && window.NvCatalog) button.disabled = published === null;
    const source = document.getElementById('nvMapLink');
    if (!source) return;
    const ready = published !== null;
    let href = source.href;
    if (ready) {
      const url = new URL(href, window.location);
      const current = new URL(window.location);
      const view = url.searchParams.get('view');
      const liveScope = window.NvCatalog && window.NvCatalog.mapScope && window.NvCatalog.mapScope();
      const scope = liveScope ? JSON.stringify(liveScope) : url.searchParams.get('catalog_scope');
      url.search = current.search;
      if (scope !== null) url.searchParams.set('catalog_scope', scope);
      // Район открывает карту в том же контроллере, город — по /na-karte/.
      if (view === 'map') url.searchParams.set('view', 'map');
      url.searchParams.delete('page');
      for (const name of [...url.searchParams.keys()]) {
        if (name.startsWith('f_')) url.searchParams.delete(name);
      }
      url.hash = key + '=' + published.map((item) => item.id).join(',');
      href = url.pathname + url.search + url.hash;
    }
    document.querySelectorAll(links).forEach((link) => {
      link.setAttribute('aria-disabled', ready ? 'false' : 'true');
      if (ready && link.getAttribute('href') !== href) link.setAttribute('href', href);
    });
  };
  const scopeQuery = () => {
    const current = new URL(window.location);
    const scope = current.searchParams.get('catalog_scope');
    if (scope === null) return '';
    const city = current.pathname.split('/')[2];
    return '&city=' + encodeURIComponent(city) + '&catalog_scope=' + encodeURIComponent(scope);
  };
  async function loadScope() {
    const items = [];
    let page = 1;
    let pages;
    do {
      const response = await fetch('/map_api.php?action=list&limit=200&fields=infra&page=' + page + scopeQuery(),
        { credentials: 'same-origin', signal: window.AbortSignal.timeout(12000) });
      if (!response.ok) throw new Error('HTTP ' + response.status);
      const data = await response.json();
      if (!data.ok || !Array.isArray(data.items)) throw new Error('Invalid catalog selection');
      items.push(...data.items);
      pages = Number(data.pages) || 1;
      page++;
    } while (page <= pages);
    return { ok: true, items };
  }
  async function load(ids) {
    const items = [];
    for (let start = 0; start < ids.length; start += 20) {
      const batch = ids.slice(start, start + 20);
      const response = await fetch('/map_api.php?action=list&limit=20&fields=infra&building_ids=' + batch.join(',') + scopeQuery(),
        { credentials: 'same-origin', signal: window.AbortSignal.timeout(12000) });
      if (!response.ok) throw new Error('HTTP ' + response.status);
      const data = await response.json();
      if (!data.ok || !Array.isArray(data.items) || Number(data.total) !== batch.length
          || data.items.length !== batch.length) throw new Error('Incomplete catalog selection');
      const byId = new Map(data.items.map((item) => [String(item.id), item]));
      if (byId.size !== batch.length || batch.some((id) => !byId.has(id))) {
        throw new Error('Changed catalog selection');
      }
      items.push(...batch.map((id) => byId.get(id)));
    }
    return { ok: true, items };
  }
  const selection = window.CatalogSelection = {
    ready() { return published !== null; },
    publish(items) { published = items.slice(); pending = null; syncLink(); },
    invalidate() { published = null; pending = null; syncLink(); },
    syncLink,
    getMapList() {
      let chosen;
      try { chosen = snapshot(); } catch (error) { return Promise.reject(error); }
      if (!chosen) return null;
      if (chosen.items) return Promise.resolve({ ok: true, items: chosen.items.slice() });
      const identity = chosen.scope ? scopeQuery() : chosen.ids.join(',') + scopeQuery();
      if (!pending || pendingKey !== identity) {
        pendingKey = identity;
        pending = (chosen.scope ? loadScope() : load(chosen.ids)).catch((error) => { pending = null; throw error; });
      }
      return pending;
    },
    getMapFilters() {
      const request = this.getMapList();
      return request && request.then((data) => ({ ok: true,
        districts: [...new Set(data.items.map((item) => item.district).filter(Boolean))].sort() }));
    },
    clearMap() {
      const url = new URL(window.location);
      const hash = hashParams();
      hash.delete(key);
      url.searchParams.delete('catalog_scope');
      url.hash = hash.toString();
      window.history.replaceState({}, '', url);
      pending = null;
    }
  };
  // Capture covers the main link, its mini-map copy, keyboard and middle click.
  for (const name of ['click', 'auxclick']) {
    document.addEventListener(name, (event) => {
      const target = event.target.closest && event.target.closest(links);
      if (!target) return;
      if (published === null || (window.NvCatalog.listState && window.NvCatalog.listState())) {
        event.preventDefault();
        return;
      }
      window.NvCatalog.writeUrl();
      selection.syncLink();
    }, true);
  }
})();
